import React, { Component } from "react";
import { Icon, Popconfirm } from "antd";

class component extends Component {
  render() {
    const onClickMethod = (method, id, message, language, item) =>
      async function(event) {
        await method[0](id);

        if(method[1]) {
          method[1](item.email, item.name, language)
        }

        message.success(message, 5);
      };
    const renderChoices = this.props.choices.map(choice => (
      <Popconfirm
        title={`Er du sikker på at du vil "${choice.title}"?`}
        onConfirm={onClickMethod(
          choice.method,
          this.props.id,
          choice.message,
          this.props.language,
          this.props.item
        )}
        onCancel={null}
      >
        <a>{choice.title}</a>
      </Popconfirm>
    ));

    function showMenu(id) {
      if(document.getElementById("dropdown" + id) && document.getElementById("dropdown" + id).style.display === "none") {
        (document.getElementById("dropdown" + id).style.display = "block")
        return;
      }

      document.getElementById("dropdown" + id).style.display = "none"
    }

    return (
      <div class="header">
        <div class="ellipsisButton" onClick={() => showMenu(this.props.id)}>
          <Icon
            type="ellipsis"
            style={{
              paddingTop: "10px",
              fontSize: "20px",
              float: "right",
              transform: "rotate(90deg)",
              color: "black"
            }}
          />
        </div>
        <div id={"dropdown" + this.props.id} class="dropdown-content">
          {renderChoices}
        </div>
      </div>
    );
  }
}

export default component;



// WEBPACK FOOTER //
// ./src/components/EllipsisButton/component.js